import Vue from 'vue'

import BlaiseIcon from './components/global/blaise-icon/BlaiseIcon.vue'
Vue.component(BlaiseIcon.name, BlaiseIcon)